/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveTag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ActiveTag({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/TreatmentSelect/Content/Content/ActiveTag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentOverlayTreatmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'treatment_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(appointmentOverlayTreatmentIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}